;(function (angular) {
  'use strict'

  angular
    .module('kilo.config', [])
  angular
    .module('kilo.common.services', [])
  angular
    .module('kilo.common.controllers', [])
  angular
    .module('kilo.common.directives', [])
  angular
    .module('kilo.common.components', [])
  angular
    .module('kilo.common.business', [])
  angular
    .module('kilo.common.filters', [])

  angular
    .module('kilo.common', [
      'kilo.common.services',
      'kilo.common.controllers',
      'kilo.common.directives',
      'kilo.common.components',
      'kilo.common.business',
      'kilo.common.filters',
      'textAngular'
    ])
})(window.angular)
